import logo from './logo.svg';
import './App.css';
import { useState } from 'react';
import PageRoute from './Route/PageRoute';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function App() {


   
 
  return (

    <div  >
       <PageRoute></PageRoute>
     {/* <input type="text" name='number' onChange={onChange} />
     <input type="text" name='password'   onChange={onChange}     />
     <button onClick={(e)=>onSubmit(e)}>Submit</button> */}
    </div>
  );
}

export default App;
